// A tab opened before a deploy keeps the old build's JavaScript in memory. When
// it later asks for one of that build's files, the new build no longer has it
// and the request 404s. A full reload fetches the new build and fixes it, so the
// error pages (app/error.tsx, app/global-error.tsx) do that once automatically.

const RELOAD_KEY = 'ghlp-chunk-reload-at'
// A second chunk error this soon after an automatic reload means reloading
// didn't help, so stop and show the error page instead of looping.
const RELOAD_WINDOW_MS = 30_000

export function isChunkLoadError(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false
  const { name = '', message = '' } = error as { name?: string; message?: string }
  return (
    name === 'ChunkLoadError' ||
    /Failed to load chunk|Loading (CSS )?chunk|dynamically imported module|Importing a module script failed/i.test(message)
  )
}

/** Reloads the page once for a stale-build chunk error. Returns true if it reloaded. */
export function reloadOnceForChunkError(error: unknown): boolean {
  if (!isChunkLoadError(error)) return false
  try {
    const last = Number(window.sessionStorage.getItem(RELOAD_KEY) || 0)
    if (Date.now() - last < RELOAD_WINDOW_MS) return false
    window.sessionStorage.setItem(RELOAD_KEY, String(Date.now()))
  } catch {
    // Storage blocked (private mode etc.): without a loop guard, don't auto-reload.
    return false
  }
  window.location.reload()
  return true
}
